import React, { useState, useEffect, useRef } from 'react';
import { useForm } from 'react-hook-form';
import { MapContainer, Marker, Popup, AttributionControl } from "react-leaflet";
import { GestureHandling } from "leaflet-gesture-handling";
import LayerControl from '../map/layer-control';

import { generateIcon } from '../map/marker';


const Map = ({ data, defaultCentre = [-41.2924, 174.7787], defaultZoom = 6, offset_path, paths, years }) => {

  return (
    <output>
      <MapContainer
        className="markercluster-map"
        center={defaultCentre}
        zoom={defaultZoom}
        maxZoom={18}
        attributionControl={false}
        whenReady={({ target:map }) => {
          map.gestureHandling.enable();

          // a11y (?) move the controls above the map in the source order
          const mapPane = document.querySelector('.leaflet-map-pane');
          const controls = document.querySelector('.leaflet-control-container');
          mapPane.before(controls);
        }}
      >
        <LayerControl />
        {data.filter(({ latitude, longitude }) => latitude && longitude).map((item, i) => (
          <MarkerWithState key={i} item={item} offset_path={offset_path} years={years} paths={paths} id={i} />

        ))}
        <AttributionControl position="bottomright" prefix={false} />
      </MapContainer>
    </output>
  )
}

export default Map;

const MarkerWithState = ({ id, item, offset_path, years, paths, ...props }) => {
  const [ isOpen, setIsOpen ] = useState(false);
  const [ download, setDownload] = useState([])

  const { watch, register } = useForm();

  const year = watch('year')
  const format = watch('format')

  useEffect(() => {
    if(year && format) {
      setDownload([paths[format], `${item.tide_prediction_file} ${year}.${format}`])
    }
  }, [year, format])

  return (
    <Marker
      {...props}
      eventHandlers={{
        popupopen: (e) => setIsOpen(true),
        popupclose: (e) => setIsOpen(false),
      }}
      icon={item.status === 'offset' ? generateIcon('grey', `Open ${item.title}`, isOpen) : generateIcon('teal', `Open ${item.title}`, isOpen)}
      keyboard={false}
      position={[item.latitude, item.isCloseToAntimeridian ? item.longitude + 360 : item.longitude]}>
        <Popup className={item.status === 'offset' ? 'has-gray-icon' : 'has-teal-icon'}>
          <h3>{item.title}</h3>
          {item.status === 'offset' && <a aria-label={`Download for ${item.title}`} download href={encodeURI([offset_path, item.tide_offset_file].join('/'))}>Download</a>}

          {item.status !== 'offset' && (
            <form className="d-flex">
              <fieldset>
                <legend>Choose a year and file format</legend>
                <select {...register('year')} id={`marker-year-${id}`}>
                  <option value="">- Year -</option>
                  {years.map(year => <option key={year} value={year}>{year}</option>)}
                </select>
                <label htmlFor={`marker-year-${id}`} className="sr-only">Year</label>
                <select {...register('format')} id={`marker-format-${id}`}>
                  <option value="">- Format -</option>
                  <option value="csv">CSV</option>
                  <option value="pdf">PDF</option>
                </select>
              <label htmlFor={`marker-format-${id}`} className="sr-only">Format</label>
            </fieldset>

            {download.length === 0 && <span>Download</span>}
            {download.length > 0 && <a aria-label={`Download for ${item.title}`} download href={encodeURI(download.join('/'))}>Download</a>}
          </form>
        )}
        </Popup>
      </Marker>
  )

}
